import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

const PostLink = ({ post }) => (
  <div className="pb-4">
    <div className="w-full lg:max-w-full lg:flex  border rounded border-light-grey">
      <Img
        className="h-48 lg:h-auto lg:w-48 flex-none bg-contain rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
        fluid={post.frontmatter.cover_image.childImageSharp.fluid}
      />
      <div className="flex w-full p-4 ">
        <Link to={post.frontmatter.path} className="no-underline text-black">
          <h2>{post.frontmatter.title}</h2>
          <p className="text-grey pb-4">{post.frontmatter.date}</p>
          <p className="text-grey-dark">{post.frontmatter.description}</p>
        </Link>
      </div>
    </div>
  </div>
)

export default PostLink
